<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <v-card class="white rounded-lg" >
          <v-card-title class="secondary--text">{{ title }}
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    depressed
                    :href="printUrlHref"
                    target="_blank"
                    class="lightSecondary mr-md-2 "
                >
                  <v-img max-height="25" max-width="25" src="/img/icons/print.svg"></v-img>
                </v-btn>
              </template>
              چاپ دسته جمعی
            </v-tooltip>

          </v-card-title>
          <v-card-text>
            <m-datatable :show-filter-row="false" :headers="cols" :apiUrl="baseUrl"
                         ref="datatable" :show-select="true"
                         @dblclick:row="(e, row) => $router.push(toOrder(row.item.id))">
            </m-datatable>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import cart from "@/components/scomponents/Cart";
import UserSelect from "@/components/selects/UserSelect";
import Swal from "sweetalert2";


export default {
  name: "AdminPackingReport",
  mixins: [MFormMixin, formsMixin, FormsMixin],
  components: {
    UserSelect,
    cart
  },

  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'packing/adminPackingReport',
      baseUrl: "packing/adminPackingReport",
      permissionBasename: "order_package",
      appendSlash: false,
      payFromWallet: false,
      hasList: false,
      discountCode: "",
      discountAmount: 0,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      admin: null,
      isDefinable: false,
      pay_amount: 0,
      myClass: '',
      ss: null,
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      first: false,
      cols: [
        {
          text: "نام کسب و کار",
          value: "business.name",
        },
        {
          text: "نام مشتری",
          value: "customer_name",
        },
        {
          text: "تعداد اقلام",
          value: "products_quantity",
          type: 'numeric'
        },
        {
          text: "زمان بسته بندی",
          value: "packing_data_time",
        },
        {
          text: "زمان پست",
          value: "shipping_data_time",
        },
      ],

    };
  },
  computed: {
    title() {
      return ' گزارش بسته بندی شما'
    },
    headers() {
      return [];
    },
    printUrlHref() {
      let path = `packing/adminPackingAllOrdersReport/html?id=${this.id}&token=${this.token}`;
      return this.endpoint(path);
    },
    pdfUrl() {
      let path = `packing/adminPackingAllOrdersReport/pdf?id=${this.id}&token=${this.token}`;
      return this.endpoint(path);
    },

  },
  updated() {
  },
  created() {
  },
  methods: {
    toOrder(id) {
      return {
        name: "OrderPackage",
        params: {
          id: id,
        },
      };
    },

  },
}
</script>

<style scoped lang="scss"></style>

